<script setup lang="ts">
import LimitedPack from '@/components/LimitedPack.vue'
import { HomeButton } from '@/components/home'
import { usePack } from '@/composables/game/shop'
import type { EcommerceItem } from '@/types/shared/player-config'
import { computed } from 'vue'

const props = defineProps<{
  limitedPack: EcommerceItem
}>()

const { countdownForLimitedPackEnd } = usePack(computed(() => props.limitedPack))

</script>

<template>
  <HomeButton
    :countdown="{ value: countdownForLimitedPackEnd, dangerThreshold: 3600 * 3 }"
    :label="limitedPack.name"
  >
    <LimitedPack :limited-pack="limitedPack" />
  </HomeButton>
</template>
<style scoped>

.white-stroke-black-text-1 {
  color: #1D1D1B;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: white;
  paint-order: stroke fill;
}
</style>
